import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { createIGSERedux } from "../../../../shared/igse-redux/igse-redux-factory";
import { getAnnouncements } from "../../service/announcements.api";

const {
    actions: announcementsActions,
    reducer: announcementsReducer,
    epic: announcementsEpic,
} = createIGSERedux<Array<string>>({
    actionNames: {
        init: "ANNOUNCEMENTS_INIT",
        get: "ANNOUNCEMENTS_GET",
        success: "ANNOUNCEMENTS_GET_SUCCESS",
        error: "ANNOUNCEMENTS_GET_ERROR",
    },
    fetcher: () => getAnnouncements(selectAuthTokens()),
});

export { announcementsActions, announcementsReducer, announcementsEpic };
